// extracted by mini-css-extract-plugin
module.exports = {"element":"link_element__3X54w","has-arrow":"link_has-arrow__39r25","blue":"link_blue__2eOu1","red":"link_red__16bvI","yellow":"link_yellow__2bSth","green":"link_green__zwLu8"};